<template>
  <div>
    <v-alert v-if="config && !config.configured" type="warning" outlined>
      {{ $t("maps_not_configured") }}
    </v-alert>
    <GoogleMapLoader
      v-else-if="config && config.provider === 'google'"
      ref="map"
      :apiKey="config.googleKey"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <MapboxMapLoader
      v-else-if="config && config.provider === 'mapbox'"
      ref="map"
      :config="config"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>
<script>
import GoogleMapLoader from "@/components/GoogleMapLoader.vue";
import MapboxMapLoader from "@/components/MapboxMapLoader.vue";
import MapConfigService from "@/services/MapConfigService";

// Renders the map with the provider selected in the super admin settings.
// Takes the same props and events as GoogleMapLoader / MapboxMapLoader.
export default {
  inheritAttrs: false,
  components: {
    GoogleMapLoader,
    MapboxMapLoader,
  },
  data() {
    return {
      config: null,
    };
  },
  created() {
    MapConfigService.getConfig().then((config) => {
      this.config = config;
    });
  },
};
</script>
